import { gql } from "@apollo/client";

export const PackageDetails = gql`
  fragment PackageDetails on AseobiPackage {
    id
    event_id
    aseobi_id
    name
    description
    cover_image
    images
    price
    currency_iso
    status
    stock_quantity
    reserved_quantity
    sold_quantity
    available_quantity
    sold_out
    version
    items {
      id
      name
      description
      images
      quantity
      unit
      display_order
    }
  }
`;
